import { hasScopedPermission, GrantsType } from '../../Shared/utils/auth';

export const viewPartnerPermission = (grants: GrantsType) => {
  const permission = 'partners.read';

  return hasScopedPermission(grants, 'partner', permission);
};
